import * as React from "../../_snowpack/pkg/react.js";
const AllSurveysList = ({
  allSurveys,
  setIdSelected,
  changeFilter,
  filter
}) => {
  const [visibleSurveys, setVisibleSurveys] = React.useState(allSurveys);
  React.useEffect(() => {
    setVisibleSurveys(allSurveys.filter((survey) => new RegExp(filter, "ig").test(survey.institution)).filter((survey) => survey.is_active));
  }, [filter, allSurveys]);
  return /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement("h2", {
    className: "text-xl font-bold text-blue-800"
  }, "Institution Responses"), /* @__PURE__ */ React.createElement("div", {
    className: "flex py-2 flex-col items-start"
  }, /* @__PURE__ */ React.createElement("label", {
    className: "pb-4 pt-1"
  }, "Filter by institution:", /* @__PURE__ */ React.createElement("input", {
    className: "ml-2 border-2 px-1 rounded-sm",
    type: "text",
    value: filter,
    onChange: (e) => changeFilter(e.target.value)
  })), /* @__PURE__ */ React.createElement("p", {
    className: "italic"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "font-bold"
  }, visibleSurveys.length), " matching survey responses available", visibleSurveys.length > 0 ? ":" : "")), /* @__PURE__ */ React.createElement("ul", {
    className: "list-disc ml-7"
  }, [...visibleSurveys].sort((a, b) => a.institution > b.institution ? 1 : -1).map((survey, idx) => /* @__PURE__ */ React.createElement("li", {
    className: "pl-1 py-2",
    key: `survey-preview/${idx}`
  }, /* @__PURE__ */ React.createElement("button", {
    onClick: (e) => {
      e.preventDefault();
      setIdSelected(survey.id);
    },
    className: "text-blue-700 underline text-left"
  }, `${survey.institution}${survey.department ? ` (${survey.department})` : ""}`)))));
};
export default AllSurveysList;
